import { useQuery } from "@tanstack/react-query";

import type { components, paths } from "@/api/types";
import type { Result } from "@/shared/api";
import { apiGet, qk } from "@/shared/api";

export type AdminRobot = Result<paths["/api/v1/admin/robots"]["get"]>[number];
export type YieldPreview = Result<paths["/api/v1/admin/robots/preview"]["post"]>;

export function useRobots() {
  return useQuery({
    queryKey: qk.robots(),
    queryFn: ({ signal }) => apiGet("/api/v1/admin/robots", { signal }),
  });
}

export function useRobot(id: number, enabled = true) {
  return useQuery({
    queryKey: qk.robot(id),
    enabled,
    queryFn: ({ signal }) =>
      apiGet("/api/v1/admin/robots/{robot_id}", { params: { robot_id: id }, signal }),
  });
}

export type AdminRobotAnalytics = Result<
  paths["/api/v1/admin/robots/{robot_id}/analytics"]["get"]
>;
export type StatPeriod = components["schemas"]["AdminStatPeriod"];

/**
 * Аналитика робота (доработки §7, «Robot analytics»).
 *
 * Отдельным запросом от карточки, а не полем в ней: форму робота открывают,
 * чтобы править поля, и тянуть ради неё агрегаты по всем покупкам незачем.
 * Период стоит в ключе — переключение окна обязано попадать в кэш, а не
 * гонять сеть по второму разу.
 */
export function useRobotAnalytics(id: number, period: StatPeriod, enabled = true) {
  return useQuery({
    queryKey: qk.robotAnalytics(id, period),
    enabled,
    queryFn: ({ signal }) =>
      apiGet("/api/v1/admin/robots/{robot_id}/analytics", {
        params: { robot_id: id },
        query: { period },
        signal,
      }),
  });
}
